import api from '../../../api';
import { COMPANIONS_API } from './constants';

/**
 * Companions API service
 */
export const companionsApi = {
    // Trips
    getTrips: (params = {}) => api.get(COMPANIONS_API.TRIPS, { params }),
    
    getTrip: (id) => api.get(COMPANIONS_API.tripDetail(id)),
    
    createTrip: (data) => {
        const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
        if (isFormData) {
            return api.post(COMPANIONS_API.TRIPS, data, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
        }
        return api.post(COMPANIONS_API.TRIPS, data);
    },
    
    updateTrip: (id, data) => api.patch(COMPANIONS_API.tripDetail(id), data),
    
    deleteTrip: (id) => api.delete(COMPANIONS_API.tripDetail(id)),
    
    // Applications
    applyToTrip: (tripId, message = '') => 
        api.post(COMPANIONS_API.tripApply(tripId), { message }),
    
    getCandidates: (tripId) => 
        api.get(COMPANIONS_API.tripCandidates(tripId)),
    
    // Request management (for trip author)
    approveRequest: (requestId) => 
        api.post(COMPANIONS_API.requestAction(requestId), { action: 'approve' }),
    
    rejectRequest: (requestId) => 
        api.post(COMPANIONS_API.requestAction(requestId), { action: 'reject' }),

    removeRequest: (requestId) =>
        api.post(COMPANIONS_API.requestAction(requestId), { action: 'remove' }),
    
    // User's own data
    getMyTrips: () => api.get(COMPANIONS_API.MY_TRIPS),
    
    getMyRequests: () => api.get(COMPANIONS_API.MY_REQUESTS),
    
    cancelMyRequest: (requestId) =>
        api.post(COMPANIONS_API.requestCancel(requestId)),

    // Trip chat
    getTripMessages: (tripId) =>
        api.get(COMPANIONS_API.tripMessages(tripId)),

    sendTripMessage: (tripId, content) =>
        api.post(COMPANIONS_API.tripMessages(tripId), { content }),
};

export default companionsApi;
